import React,{createRef, useState} from 'react';
import About from "../Body/About.jsx"
import Footer from '../Footer/Footer.jsx';
import Award from '../Body/Award.jsx';
import Experience from '../Body/Experience.jsx';
import Project from '../Body/Project.jsx';
import Home from '../Body/Home.jsx';
import Skill from '../Body/Skill.jsx';

const Header = () => {
	const [isVisible, setstate] = useState(false)

	const toggleVisible = () => {
		setstate(!isVisible)
	}
    
	return (
		<div className='sticky top-0 z-10'>
			<nav className='sticky top-0 z-10 bg-blue-500'>
				<div className='w-full mx-auto px-2 pb-2'>
					<div className='flex justify-between'>
						<div className='flex space-x-4'>
							<div className='absolute'>
								{/* Website Logo */}
								<a href='#home' className='flex items-center py-4 px-2'>
									{/* <img src="/logo.jpg" alt="img error" className="h-8 w-8 mr-2"/> */}
									<span className='font-semibold text-white text-lg'>
										Benedictus Visto Kartika
									</span>
								</a>
							</div>
							{/* Primary Navbar items */}
							<div className='hidden md:flex w-screen justify-center space-x-2'>
								<a
									href='#about'
									className='py-4 px-2 text-white hover:text-gray-300 transition duration-300 text-md'
								>
									About
								</a>
								<a
									href='#projects'
									className='py-4 px-2 text-white hover:text-gray-300 transition duration-300 text-md'
								>
									Projects
								</a>

								<a
									href='#experiences'
									className='py-4 px-2 text-white hover:text-gray-300 transition duration-300 text-md'
								>
									Experiences
								</a>

								<a
									href='#awards'
									className='py-4 px-2 text-white hover:text-gray-300 transition duration-300 text-md'
								>
									Awards
								</a>

								<a
									href='#skills'
									className='py-4 px-2 text-white hover:text-gray-300 transition duration-300 text-md'
								>
									Skills
								</a>

								<a
									href='#contacts'
									className='py-4 px-2 text-white hover:text-gray-300 transition duration-300 text-md'
								>
									Contacts
								</a>
							</div>
						</div>

						{/* Secondary Navbar items */}
						{/* <div className='hidden md:flex items-center space-x-3 '>
							<a
								href='/login'
								className='py-2 px-2 font-medium text-white rounded hover:text-gray-300 transition duration-300'
							>
								Log In
							</a>
							<a
								href=''
								className='py-2 px-2 font-medium text-white rounded hover:text-gray-300 transition duration-300'
							>
								Sign Up
							</a>
						</div> */}

						{/* Mobile menu button */}
						<div className='md:hidden flex items-center' onClick={toggleVisible}>
							<button className='outline-none'>
								<svg
									className=' w-6 h-6 text-white hover:text-blue-400 '
									x-show='!showMenu'
									fill='none'
									strokeLinecap='round'
									strokeLinejoin='round'
									strokeWidth='2'
									viewBox='0 0 24 24'
									stroke='currentColor'
								>
									<path d='M4 6h16M4 12h16M4 18h16'></path>
								</svg>
							</button>
						</div>
					</div>
				</div>
				<div className={`${isVisible ? "block" : "hidden"}`}>
					<ul className=''>
						<li className='active'>
							<a
								href='index.html'
								className='block text-sm px-2 py-4 text-white bg-blue-500 hover:bg-blue-400 duration-300'
							>
								About
							</a>
						</li>
						<li>
							<a
								href='#services'
								className='block text-sm px-2 py-4 text-white hover:bg-blue-400 transition duration-300'
							>
								Projects
							</a>
						</li>

						<li>
							<a
								href='#about'
								className='block text-sm px-2 py-4 text-white hover:bg-blue-400 transition duration-300'
							>
								Experiences
							</a>
						</li>

						<li>
							<a
								href='#about'
								className='block text-sm px-2 py-4 text-white hover:bg-blue-400 transition duration-300'
							>
								Honor and Awards
							</a>
						</li>

						<li>
							<a
								href='#about'
								className='block text-sm px-2 py-4 text-white hover:bg-blue-400 transition duration-300'
							>
								Skills
							</a>
						</li>

						<li>
							<a
								href='#about'
								className='block text-sm px-2 py-4 text-white hover:bg-blue-400 transition duration-300'
							>
								Contacts
							</a>
						</li>
					</ul>
				</div>
			</nav>
			<div id="home">
				<Home />
			</div>
			<div id="about">
				<About />
			</div>
			<div id="projects">
				<Project />
			</div>
			<div id="experiences">
				<Experience />
			</div>
			<div id="awards">
				<Award />
			</div>
			<div id="skills">
				<Skill />
			</div>
			<div id="contacts">
				<Footer />
			</div>
		</div>
	)
}

export default Header
